import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getProductionStepDetails, updateProductionStep } from "../../helpers/http_production_steps_requests";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export default function ProductionStepUpdate() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getProductionStepDetails", id],
        queryFn: () => getProductionStepDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: stepData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Etapa - Editar",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "position",
                    label: "Ordem",
                    type: "number",
                    required: true,
                },
                {
                    name: "is_active",
                    label: "Ativa",
                    type: "switch",
                },
            ],
        },
    ];

    const handleSubmit = (formData) => {
        updateProductionStep(
            {
                id: Number(id),
                name: formData.name,
                position: Number(formData.position) || 0,
                is_active: Boolean(formData.is_active),
            },
            () => {
                queryClient.invalidateQueries({ queryKey: ["getProductionSteps"] });
                navigate("/configuracao-etapas");
            }
        );
    };

    return (
        <DynamicFormPage
            isLoading={isFetching}
            initialData={stepData}
            title="Etapa - Editar"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
            onSubmit={handleSubmit}
        />
    );
}
